import { motion } from "framer-motion";
import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

/**
 * Subtle fade + tiny lift between routes. Respects reduced-motion via
 * framer-motion's built-in handling.
 */
const PageTransition = ({ children }: PageTransitionProps) => (
  <motion.div
    initial={{ opacity: 0, y: 6 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -4 }}
    transition={{ duration: 0.25, ease: "easeOut" }}
    className="flex-1"
  >
    {children}
  </motion.div>
);

export default PageTransition;
